import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    position: 'relative',
    height: '100%',
    '@media(max-width: 900px)': {
      height: '300px',
    }
  },
  headerContainer: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
});

